export default "__VITE_ASSET__DNtj7I5e__"